import { SyncOutlined } from '@ant-design/icons'
import { Button } from '@sureco/design-system'
import React from 'react'
import { CensusFileRowGridData } from '../../types/census-file-row-grid-data'
import { useCategoriseRows } from '../hooks/useCategoriseRows'

interface CategoriseAllButtonProps {
  publicKey: string
  censusRows: CensusFileRowGridData[]
  handleSubmit: () => void
  setPageLoading: (loading: boolean) => void
}

const CategoriseAllButton = ({
  publicKey,
  censusRows,
  handleSubmit,
  setPageLoading,
}: CategoriseAllButtonProps) => {
  const { categorise, loading } = useCategoriseRows({
    publicKey,
    onComplete: handleSubmit,
    setPageLoading,
  })

  return (
    <Button
      onClick={() => categorise(censusRows)}
      size="large"
      loading={loading}
      disabled={censusRows.length === 0}
    >
      <SyncOutlined style={{ marginRight: '8px' }} />
      {loading ? 'Categorising...' : 'Categorise All'}
    </Button>
  )
}

export default CategoriseAllButton
